//
// Reusable/default dynamic layout that simply renders the components/elements returned from the API
//
import React, { Fragment, useMemo } from 'react'

import { useSurveyContext } from '../../_store'
import { BooleanSelect, MultiSelect, SingleSelect } from '../_components'

import Header00 from './Header00'

const DefaultLayout = ({ step }) => {
  const { state } = useSurveyContext()
  const components = state.pages[`step_${step}`].page.layoutContent.components
  const dataSelectedOptions = state.pages[`step_${step}`].formData
  const keys = Object.keys(dataSelectedOptions)
  const unknownKeyName = keys[0]
  const arrayDataOptions = dataSelectedOptions[unknownKeyName] // Access the array using the unknown key

  return useMemo(
    () => (
      <Fragment>
        <Header00 step={step} />
        {components &&
          components.map((component, index) => {
            switch (component.type) {
              case 'single-select-1':
                return (
                  <SingleSelect
                    component={component}
                    key={component.slug}
                    step={step}
                    updatedSelected={dataSelectedOptions[keys[index]]}
                  />
                )
              case 'boolean-1': {
                return (
                  <BooleanSelect
                    component={component}
                    key={component.slug}
                    step={step}
                  />
                )
              }
              case 'multi-select-1':
              case 'multi-select-2':
              case 'multi-select-3':
              case 'multi-select-4':
                return (
                  <MultiSelect
                    component={component}
                    key={component.slug}
                    step={step}
                    updatedSelected={dataSelectedOptions[keys[index]]}
                  />
                )
            }
          })}
      </Fragment>
    ),
    [step, dataSelectedOptions]
  )
}

export default DefaultLayout
